type RNMessageKey =
  | 'share'
  | 'link'
  | 'setUserId'
  | 'flarelane_trackEvent'
  | 'flarelane_subscribe'
  | 'permission'
  | 'deviceInfo'
  | 'getCurrentPosition';

interface postMessageToRNParams {
  messageKey: RNMessageKey;
  messageParam?: string;
  messageData?: object;
}

export const postMessageToRN = ({ messageKey, messageParam, messageData }: postMessageToRNParams) => {
  let messageObj;

  switch (messageKey) {
    case 'share':
      messageObj = {
        key: messageKey,
        param: messageParam,
      };
      break;

    case 'link':
      messageObj = {
        key: messageKey,
        param: { url: messageParam },
      };
      break;

    case 'setUserId':
      messageObj = {
        key: messageKey,
        param: { userId: messageParam ?? null },
      };
      break;

    case 'flarelane_subscribe':
      messageObj = {
        key: messageKey,
        param: { key: messageParam },
      };
      break;

    case 'flarelane_trackEvent':
      messageObj = {
        key: messageKey,
        param: { eventName: messageParam, messageData },
      };
      break;

    case 'permission':
      messageObj = {
        key: messageKey,
        param: { key: messageParam, messageData },
      };
      break;

    default:
      messageObj = {
        key: messageKey,
      };
      break;
  }

  window.ReactNativeWebView.postMessage(JSON.stringify(messageObj));
};
